module.exports = __webpack_public_path__ + "img/catalogo-completo-exotics-thumb.af0ae229.png";